// Elegant typography scale
export const typography = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  
  // Type scale
  h1: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: 1.2,
    color: '#1a1a1a'
  },
  h2: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#1a1a1a'
  },
  h3: {
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: 1.4,
    color: '#1a1a1a'
  },
  body: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#1a1a1a'
  },
  bodySecondary: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#6b7280'
  },
  caption: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.4,
    color: '#6b7280'
  },
  small: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.3,
    color: '#6b7280'
  }
};

// Elegant color palette
export const colors = {
  // Text colors
  text: {
    primary: '#1a1a1a',
    secondary: '#6b7280',
    muted: '#9ca3af'
  },
  
  // Background colors
  background: {
    page: '#fafafa',
    surface: '#ffffff',
    subtle: '#f9fafb'
  },
  
  // Accent colors
  accent: {
    purple: '#8b5cf6',
    orange: '#f97316'
  },
  
  // Critical colors
  critical: {
    text: '#dc2626',
    background: '#fef2f2',
    border: '#fecaca'
  },
  
  // Primary colors
  primary: {
    main: '#3b82f6',
    dark: '#2563eb',
    light: '#60a5fa'
  },
  
  // Status colors
  status: {
    error: '#dc2626',
    warning: '#f59e0b', 
    success: '#059669'
  },
  
  // Action colors
  action: {
    primary: '#3b82f6',
    primaryHover: '#2563eb'
  },
  
  // Border colors
  border: {
    light: '#f3f4f6',
    medium: '#e5e7eb',
    dark: '#d1d5db'
  },
  
  // Shadow colors
  shadow: {
    subtle: 'rgba(0, 0, 0, 0.05)',
    soft: 'rgba(0, 0, 0, 0.1)',
    medium: 'rgba(0, 0, 0, 0.15)'
  }
};

// Spacing system (8px base)
export const spacing = {
  xs: '8px',
  sm: '16px',
  md: '24px',
  lg: '32px',
  xl: '48px',
  xxl: '64px'
};

// Mobile-first typography for promotions
export const promotionTypography = {
  heroTitle: {
    fontSize: { xs: '1.75rem', md: '2rem' }, // 28px mobile, 32px desktop
    fontWeight: 700,
    lineHeight: 1.2,
    color: '#1a1a1a'
  },
  discountLarge: {
    fontSize: { xs: '1.5rem', md: '1.75rem' }, // 24px mobile, 28px desktop
    fontWeight: 600,
    lineHeight: 1.1,
    color: '#1a1a1a'
  },
  priceDisplay: {
    fontSize: { xs: '1.125rem', md: '1.25rem' }, // 18px mobile, 20px desktop
    fontWeight: 500,
    lineHeight: 1.3,
    color: '#1a1a1a'
  },
  codeDisplay: {
    fontSize: { xs: '1rem', md: '1.125rem' }, // 16px mobile, 18px desktop
    fontWeight: 600,
    fontFamily: "'Monaco', 'Consolas', 'Courier New', monospace",
    letterSpacing: '0.5px'
  },
  badge: {
    fontSize: { xs: '0.875rem', md: '1rem' }, // 14px mobile, 16px desktop
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  }
};